<template>
  <PageContent>
    <section class="case-study">
      <h4>
        Bismarck Analysis examines institutions, industries, and individuals on
        behalf of our clients. While much of our work is confidential, we
        occasionally make select analytical products available to the general
        public.
      </h4>

      <img class="case-study-image" src="/images/machine-tools.jpeg" />
      <section class="case-study-content">
        <h3>Machine Tools: A Case Study In Advanced Manufacturing</h3>
        <p>
          This case study investigates where machine tools are built, why they&rsquo;re
          built in those places, and what this tells us about industrial policy more broadly.
        </p>
        <p><a href="/Machine_Tools_Case_Study.pdf"
          >Read the case study here.</a
        ></p>
      </section>

      <img class="case-study-image" src="/images/bomb1.jpg" />
      <section class="case-study-content">
        <h3>The Scientists, the Statesmen, and the Bomb</h3>
        <p>
          This case study examines the failed attempt of atomic scientists to establish international control of nuclear weapons and what this failure tells us about the divisions between modern science and politics.
        </p>
        <p><a href="/Nuclear_Weapons_Development_Case_Study.pdf"
          >Read the case study here.</a
        ></p>
      </section>
    </section>
  </PageContent>
</template>

<script>
import PageContent from "./PageContent.vue";
export default {
  name: "Analysis",
  components: { PageContent },
  beforeCreate() {
    document.title = "Bismarck Analysis | Analysis";
  },
};
</script>

<style scoped>
h4 {
  margin-top: 1em;
  padding-bottom: 0.5em;
  margin-bottom: 3em;
  padding-right: 20px;
}

img {
  width: 220px;
  margin-right: 2em;
  float: left;
}

.case-study {
  display: flex;
  flex-wrap: wrap;
}

.case-study-image {
  min-width: 200px;
  width: 200px;
  max-width: 400px;
  object-fit: contain;
  align-self: flex-start;
  flex: 1 1 auto;
  padding-bottom: 20px;
}

.case-study-content {
  flex: 1 1 auto;
  min-width: 300px;
  max-width: max(calc(100% - 250px), 400px);
  padding-bottom: 40px;
}

.case-study-content h3 {
  margin-top: 0px;
}
.case-study-content h4 {
  margin-top: 0px;
  padding-bottom: 0.5em;
}

</style>
